import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "../brand/Logo";
import { NAV, SITE } from "../../config/site";
import { scrollToId } from "../../lib/api";
import { WhatsAppButton } from "../common/WhatsAppButton";

const ContactLine = ({ icon: Icon, href, children, testid }) => (
  <li>
    <a href={href} data-testid={testid} className="link-lux inline-flex items-center gap-3 text-sm text-[#E8D6B7]/85 hover:text-[#F8F3E9]" target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
      <Icon className="h-4 w-4 text-[#B18A4A]" strokeWidth={1.4} aria-hidden="true" />{children}
    </a>
  </li>
);

export const Footer = ({ onHome = true }) => {
  const c = SITE.contact;
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#26231F] text-[#F8F3E9]" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-16 sm:px-8 lg:px-12">
        <div className="grid gap-12 border-b border-[#B18A4A]/20 pb-12 lg:grid-cols-[1.2fr_2fr_1fr]">
          <div>
            <Logo tone="ivory" />
            <p className="font-serif-lux mt-5 max-w-xs text-xl italic text-[#E8D6B7]">The Water Behind Exceptional Hospitality.</p>
          </div>
          <nav aria-label="Footer">
            <ul className="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  {onHome ? (
                    <button type="button" onClick={() => scrollToId(n.id)} data-testid={`footer-link-${n.id}`} className="link-lux text-sm text-[#F8F3E9]/75 hover:text-[#F8F3E9]">{n.label}</button>
                  ) : (
                    <Link to={`/#${n.id}`} data-testid={`footer-link-${n.id}`} className="link-lux text-sm text-[#F8F3E9]/75 hover:text-[#F8F3E9]">{n.label}</Link>
                  )}
                </li>
              ))}
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="link-lux text-sm text-[#F8F3E9]/75 hover:text-[#F8F3E9]">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="link-lux text-sm text-[#F8F3E9]/75 hover:text-[#F8F3E9]">Terms &amp; Conditions</Link></li>
            </ul>
          </nav>
          <ul className="space-y-3">
            {c.email && <ContactLine icon={Mail} href={`mailto:${c.email}`} testid="footer-email">{c.email}</ContactLine>}
            {(c.phones || []).map((p, i) => <ContactLine key={p} icon={Phone} href={`tel:${p.replace(/\s/g, "")}`} testid={`footer-phone-${i}`}>{p}</ContactLine>)}
            {c.whatsapp && <li className="pt-2"><WhatsAppButton testid="footer-whatsapp-btn" /></li>}
            {c.address && <li className="flex gap-3 text-sm text-[#E8D6B7]/85"><MapPin className="h-4 w-4 shrink-0 text-[#B18A4A]" strokeWidth={1.4} />{c.address}</li>}
            {c.instagram && <ContactLine icon={Instagram} href={c.instagram} testid="footer-instagram">Instagram</ContactLine>}
            {c.linkedin && <ContactLine icon={Linkedin} href={c.linkedin} testid="footer-linkedin">LinkedIn</ContactLine>}
          </ul>
        </div>
        <div className="flex flex-col gap-3 pt-8 text-xs tracking-[0.14em] text-[#F8F3E9]/60 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {year} TOYAM. All rights reserved.</p>
          <p className="uppercase tracking-[0.28em] text-[#E8D6B7]/80">Crafted in Agra. Inspired by Hospitality.</p>
        </div>
      </div>
    </footer>
  );
};
